import { XCircleIcon } from '@heroicons/react/20/solid'
const ErrorAlert = ({ title, message }) => {
    return (
        <div className="rounded-md bg-red-50 p-4 mb-3">
            <div className="flex">
                <div className="flex-shrink-0">
                    <XCircleIcon className="h-5 w-5 text-red-400" aria-hidden="true" />
                </div>
                <div className="ml-3">
                    <h3 className="text-sm font-medium text-red-800">{title}</h3>
                    {message &&
                        <div className="mt-2 text-sm text-red-700">
                            <p className=" space-y-1 pl-5">
                                {message}
                            </p>
                        </div>
                    }
                </div>
            </div>
        </div>
    )
};
export default ErrorAlert;